import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import ar from './locales/ar.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      ar: { translation: ar },
      en: { translation: en },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'ar', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      // French-first: only restore from localStorage (explicit user choice).
      // No browser-language sniffing — first-time visitors always get FR via fallbackLng.
      order: ['localStorage'],
      lookupLocalStorage: 'rently_lang',
      caches: ['localStorage'],
    },
  });

// Set dir and lang on <html> whenever language changes
const applyDirection = (lng) => {
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};
applyDirection(i18n.language);
i18n.on('languageChanged', applyDirection);

export default i18n;
